import type { EditVarianceTypeEnum } from '@webapp/platform/iam/entities/enums/EditVarianceTypeEnum'

export interface UserPurchasePriceLimitConstructor {
  id: number
  dateModified: ISODateString
  restrictEditableVariance: boolean
  editVarianceType: EditVarianceTypeEnum
  varianceThresholdLimit: string
}

export class UserPurchasePriceLimit {
  id: number
  dateModified: Date
  restrictEditableVariance: boolean
  editVarianceType: EditVarianceTypeEnum
  varianceThresholdLimit: number

  constructor(data: UserPurchasePriceLimitConstructor) {
    this.id = data.id
    this.dateModified = new Date(data.dateModified)
    this.restrictEditableVariance = data.restrictEditableVariance
    this.editVarianceType = data.editVarianceType
    this.varianceThresholdLimit = Number(data.varianceThresholdLimit)
  }
}
